"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _project = require("@/api/project/project");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "组别名称"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "组别名称",
        prop: "groupName",
        isShow: true,
        width: "400"
      }, {
        name: "创建时间",
        prop: "createTime",
        isShow: true,
        width: "300",
        sortable: true
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      checkBoxs: [],
      groupName: ""
    };
  },
  methods: {
    // 模糊搜索
    search: function search(e) {
      this.groupName = e.queryValue;
      this.getGroupList();
    },
    // 获取项目下组别列表
    getGroupList: function getGroupList() {
      var _this = this;
      (0, _project.groupList)({
        groupName: this.groupName,
        matchId: this.$route.query.matchId,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        if (res.code === 2000) {
          var data = res.data;
          console.log(res);
          _this.listData = data.list;
          _this.totalData = data.total;
        }
      });
    },
    // 删除操作
    deleteItem: function deleteItem(row) {
      var _this2 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _project.groupDel)(id).then(function () {
          _this2.getGroupList();
          _this2.$message.success("操作成功。");
        });
      }).catch(function () {
        _this2.$message.info("取消删除。");
      });
    },
    // 编辑操作
    edit: function edit(e) {
      this.$router.push({
        path: "/object/objectGroupSetEdit",
        query: e
      });
    },
    listBureau: function listBureau() {},
    morePublishout: function morePublishout() {},
    morePublish: function morePublish() {},
    dels: function dels() {},
    // 新增
    save: function save() {
      this.$router.push({
        path: "/object/objectGroupSet-add",
        query: {
          matchId: this.$route.query.matchId
        }
      });
    },
    editBureau: function editBureau() {},
    handleSelectionChange: function handleSelectionChange(e) {
      var _this3 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this3.checkBoxs.push(item.id);
      });
    },
    deleteById: function deleteById() {},
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getGroupList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getGroupList();
    }
  },
  created: function created() {
    // this.groupName = this.$route.query.matchName;
    this.getGroupList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};